export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-arrow-up-abb979689a83270aeb4c8ea00e6d00e4.svg";